const BookSkeleton = () => {
    return (
        <div className="col-12 col-md-6 col-lg-3 g-mb-30">
            <div className="u-shadow-v20 g-bg-white rounded g-pa-20">
                <div className="g-pos-rel g-mb-20" style={{ 
                    height: '200px', 
                    backgroundColor: '#f8f9fa',
                    animation: 'pulse 1.5s infinite'
                }}></div>
                <div>
                    <div className="d-flex flex-column">
                        <div className="skeleton-text g-mb-1" style={{ 
                            height: '20px',
                            width: '80%',
                            backgroundColor: '#f8f9fa',
                            animation: 'pulse 1.5s infinite'
                        }}></div>
                        <div className="skeleton-text g-mb-1" style={{ 
                            height: '16px',
                            width: '60%',
                            backgroundColor: '#f8f9fa',
                            animation: 'pulse 1.5s infinite'
                        }}></div>
                        <div className="skeleton-text g-mb-3" style={{ 
                            height: '24px',
                            width: '40%',
                            backgroundColor: '#f8f9fa',
                            animation: 'pulse 1.5s infinite'
                        }}></div>
                        <div className="skeleton-button" style={{ 
                            height: '38px',
                            width: '100%',
                            backgroundColor: '#f8f9fa',
                            animation: 'pulse 1.5s infinite'
                        }}></div>
                    </div>
                </div>
            </div>
            <style>
                {`
                    @keyframes pulse {
                        0% {
                            opacity: 1;
                        }
                        50% {
                            opacity: 0.5;
                        }
                        100% {
                            opacity: 1;
                        }
                    }
                `}
            </style>
        </div>
    );
};

export default BookSkeleton; 